import { ContextMenu } from "../context";
import { useContext } from "react"

export const useContextMenu = () => useContext(ContextMenu)